export type TMsiValueSliceState = {
    vesselListMsiValue: TVesselListMsiValue | null;    
    vesselListRecentSales: TVesselListRecentSales | null;
    summaryMsiValue: TSummaryMsiValue | null;
    msiValueState: TMsiValueState | null;
};

export interface IValueVessel
{  
    imoNumber: number;
    name: string;
    sectorId: number    
    sectorName: string
    size: number
    sizeUnit: string
    age: number
    yearOfDelivery: number 
    iceClass: string
    countryOfBuild: string
    yardTier: string
    gear: string
    hatch: string
    scrubberFitted: string
    engine: string
    fuelSystem: string
    owner: string
    gearTankCargoContainment: string,
    efficiency: number
    quarterRampCapacity: number
    hoistableDecks: number
    tank: string
    imoClassAndCoating: string
    pumpRoom: string
    propulsionSystem: string
    dwtCapacity: number
    reeferPlugs: number
    homogeneousIntake: number
    eco: string
    cargoContainment: string
    ammoniaCarrier: string
}


export type TSummaryMsiValue = {
    dataList: TSummaryMsiValueItem[] | null;
    infoNote: string;
    loading: boolean;
    loadingError: Error | null;
}

export type TSummaryMsiValueItem = {
    sector: string  
    ships: number
    averageSize: number
    sizeUnit: string    
    averageAge: number
    fairMarketValue: number    
};

export type TVesselListRecentSales = {
    dataList: TVesselRecentSales[] | null;
    loading: boolean;
    loadingError: Error | null;
}

export type TVesselRecentSales = {
    imoNumber: number | null;
    vesselRecentSales: TVesselRecentSalesItem[] | null;
};

export type TVesselRecentSalesItem = {
    imoNumber: number
    name: string
    size: number
    sizeUnit: string
    countryOfBuild: string
    yardTier: string
    ageAtSale: number
    buyer: string
    seller: string
    saleDate: string
    salePrice: number
    notes: string
};

export type TVesselListMsiValue = {
    dataList: TVesselMsiValue[] | null;
    loading: boolean;
    loadingError: Error | null;
}

export type TVesselMsiValue = {
    summary: TSummary | null;
    monthlyChart: TMonthlyChart | null;
    imoNumber: number| null;

};

export type TSummary = {
    age: number;
    infoNote: string;
    scrapValue: string;
    fairMarketValue: string;
    newbuildingContractPrice: string;
};

export type TMonthlyChart = {
    expressions: TExpressions | null;
    chartDataItemList: TChartDataItemList | null;
};

export type TExpressions = {
    realisedSales: string;
    fairMarketValue: string;
};

export type TChartDataItemList = {
    month: string;
    realisedSales: number;
    fairMarketValue: number;
};

export type TMsiValueState = {
    msiValueData: TMsiValue | null;
    loadingError: Error | null;
    loading: boolean;
};

export type TMsiValue = {
    msiValue: number | null;
    calculatedImoCount: number | null;
    imoCount: number | null;
    coveragePercentage: number | null;
};

// Slice name in the ...Slice.ts file
export const MSI_VALUE = 'msiValue';

// Action name in ...Slice.ts file that will be called from component
export const GET_MSI_VALUE = `${MSI_VALUE}/getMsiValueRequestAction`;
export const GET_VESSEL_MSI_VALUE = `${MSI_VALUE}/getVesselMsiValueRequestAction`;
export const GET_VESSEL_RECENT_SALES = `${MSI_VALUE}/getVesselRecentSalesRequestAction`;
export const GET_SUMMARY_MSI_VALUE = `${MSI_VALUE}/getSummaryMsiValueRequestAction`;